<template>
  <b-list-group-item style="text-align:left; border:0px; padding:0.25vw 0 0.25vw 0vw">
    <strong>{{data.Date}}</strong>: 
    <span v-html="data.Content" />
  </b-list-group-item>
</template>

<script>
import { BListGroupItem } from "bootstrap-vue"


export default {
  name: 'News',
  props: ["data"],
  components:{
    BListGroupItem
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color:black;
}
</style>
